
import { prototype } from 'module';
<template>
  <div>
    <div class='clpp-api-name clpp-api-title' :class="{'clpp-api-deprecated': isDeprecated}">
        {{eventSignature}} = '{{eventType}}'
    </div>

<!--    <div class='clpp-api-level v-space' v-if='eventType'>-->
<!--      <span class='clpp-api-label'>Event-Type:</span> <span class="event-type" v-html='eventType'></span>-->
<!--    </div>-->

    <div class='clpp-api-level v-space-top'>
      <div class='clpp-api-description' v-html="description" v-if='description'>{{description}}</div>
    </div>

    <div class='clpp-api-level' v-if='properties.length'>
      <h4>Properties</h4>
      <div class="clpp-api-level v-space-bottom clpp-api-prop-table">
        <table>
          <thead>
          <tr>
            <th class="name-header-column">Name</th>
            <th class="type-header-column">Type</th>
            <th class="description-header-column" width="100%">Description</th>
          </tr>
          </thead>
          <tbody>
            <DocsDetailParameter v-for='p in properties' :key='p.name' :entry='p' :parent='entry'/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import DocsDetailParameter from './DocsDetailParameter.vue';
import { DocsComponentMixin } from '../../utils/docs';

export default {
  mixins: [DocsComponentMixin],

  name: 'DocsDetailEvent',
  components: {
    DocsDetailParameter
  }
};
</script>
